import {
  call, put, select, takeLatest, takeEvery,
} from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import findResult, {
  isValidFilter,
  wildcardFilter,
} from '@/utils/resultsHelper';
import MembershipService from '@/users/membership/service';
import { shareAPISaga } from '@/users/membership/helper';
import selectors from '@/selectors';
import {
  updateCurrentCohortPermissions,
  showCohortMembers,
  showCohortMembersError,
  shareCohortError,
  shareCohortSuccess,
} from '../actions';
import { cohortLists, cohortPermissions } from '../../constants';
import cohortSharingActions from '../constants';
import { destroyCohort, refreshCohorts } from '../../actions';

export function* fetchCohortMembers(action) {
  const items = yield select(selectors.cohorts);
  const item = findResult(items, action.category, action.code);
  const members = action.assignable ? item.unassignedMembers : item.members;

  const filter = action.filter || members.filter;
  if (!isValidFilter(filter, members)) { return; }

  const { response, error } = yield call(
    callAdapter,
    MembershipService.entityMembers('cohort', item.code, wildcardFilter(filter), action.assignable),
  );

  if (error) {
    yield put(showCohortMembersError(action.category, action.code, error, action.assignable));
  } else {
    yield put(showCohortMembers(
      action.category,
      action.code,
      response.items,
      response.paging.total,
      action.assignable,
    ));
  }
}

export function* share() {
  yield shareAPISaga(
    'cohort',
    cohortPermissions,
    cohortLists,
    selectors.sharingCohort,
    selectors.cohorts,
    shareCohortError,
    shareCohortSuccess,
    refreshCohorts,
    destroyCohort,
    updateCurrentCohortPermissions,
  );
}

export default function* cohortSharingApi() {
  yield takeEvery(cohortSharingActions.FETCH_COHORT_MEMBERS, fetchCohortMembers);
  yield takeLatest(cohortSharingActions.SHARE_COHORT, share);
}
